import { type Material, type Mesh, type Object3D } from "three";
import type { GLTF } from "three/examples/jsm/Addons.js";
import type { Nullable, Nullish } from "@/types";
import { COLOUR, COLOUR_VARIANT } from "../resources/constants.ts";

export async function getMaterials(gltf: Nullable<GLTF>) {
    return getDependencies(gltf, "material");
}

export async function getMeshes(gltf: Nullable<GLTF>) {
    return getDependencies(gltf, "mesh");
}

export async function getNodes(gltf: Nullable<GLTF>) {
    return getDependencies(gltf, "node");
}

export async function getMaterialByColourVariant(gltf: Nullable<GLTF>, colour: string, colourVariant: string) {
    const materials = await getMaterials(gltf);
    return materials.find((material) => {
        return (
            material.userData[COLOUR] === colour &&
            (material.userData[COLOUR_VARIANT] as Nullish<string>)?.includes(colourVariant)
        );
    });
}

export const getMeshColourVariant = (mesh: Mesh): Nullable<string> => {
    return (mesh.userData[COLOUR_VARIANT] as Nullish<string>) ?? null;
};

function getParser(gltf: Nullable<GLTF>) {
    return gltf?.parser ?? null;
}

function getDependencies(gltf: Nullable<GLTF>, dep: "material"): Promise<Material[]>;
function getDependencies(gltf: Nullable<GLTF>, dep: "mesh"): Promise<Mesh[]>;
function getDependencies(gltf: Nullable<GLTF>, dep: "node"): Promise<Object3D[]>;
function getDependencies(gltf: Nullable<GLTF>, dep: string) {
    return getParser(gltf)?.getDependencies(dep);
}
